import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);
dayjs.extend(localeData);

const originalDayjs = dayjs;
export const CUSTOM_TIME_ZONE = 'Asia/Tokyo';
const HAS_TOME_OFFSET = /Z|[+-]\d\d:\d\d$/;
const DATE_FORMAT = /^\d{4}-\d{2}-\d{2}$/;

const dayjsCustom: any = (...args: Parameters<typeof dayjs>) => {
  const isEmpty = (val: any) => val == null || val === '';

  if (args.length === 0 || isEmpty(args[0])) {
    return dayjs().tz(CUSTOM_TIME_ZONE);
  }

  const input = args[0];

  if (typeof input === 'string') {
    if (input.match(HAS_TOME_OFFSET)) {
      return dayjs.utc(input).tz(CUSTOM_TIME_ZONE);
    }

    if (DATE_FORMAT.test(input)) {
      return dayjs.tz(input, 'YYYY-MM-DD', CUSTOM_TIME_ZONE);
    }

    return dayjs.tz(input, CUSTOM_TIME_ZONE);
  }

  if (input instanceof Date) {
    const year = input.getFullYear();
    const month = String(input.getMonth() + 1).padStart(2, '0');
    const day = String(input.getDate()).padStart(2, '0');
    const localDateStr = `${year}-${month}-${day}`;
    return dayjs.tz(localDateStr, CUSTOM_TIME_ZONE);
  }

  if (dayjs.isDayjs(input)) {
    const year = input.year();
    const month = String(input.month() + 1).padStart(2, '0');
    const day = String(input.date()).padStart(2, '0');
    return dayjs.tz(`${year}-${month}-${day}`, CUSTOM_TIME_ZONE);
  }

  return dayjs.tz(input, CUSTOM_TIME_ZONE);
};

Object.assign(dayjsCustom, {
  ...dayjs,
  tz: dayjs.tz,
  utc: dayjs.utc,
  extend: dayjs.extend,
  locale: dayjs.locale
});

dayjsCustom.tz.setDefault(CUSTOM_TIME_ZONE);

export default dayjsCustom;
export { originalDayjs };
